import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader';
import { Container } from 'listing/layout/';
import { Toggle } from 'core/hoc';
import Close from 'core/icons/Close';

import {
	Banner,
	Message,
	Flex,
	IconWrapper,
} from './notificationStyles';
import Timeout from 'core/components/Timeout';
import { Transition } from 'react-transition-group';

class Notification extends PureComponent {
	render () {
		const { message } = this.props;
		return (
			<Toggle simple open>{({ on, toggle }) => (
				<Transition in={on} timeout={250} unmountOnExit>{status => (
					<Banner onClick={this.props.delay ? toggle : null} status={status} dismissable={!! this.props.delay}>
						<Container>
							<Flex>
								<Message dangerouslySetInnerHTML={{ __html: message }} />
								{this.props.delay && (
									<IconWrapper>
										<Close />
									</IconWrapper>
								)}
							</Flex>
						</Container>
						{!! this.props.delay && <Timeout fn={toggle} delay={this.props.delay } />}
					</Banner>
				)}</Transition>
			)}</Toggle>
		);
	}

	static propTypes = {
		message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
		contentful: PropTypes.bool,
		delay: PropTypes.number,
	}
}

export default hot(module)(Notification);
